/**
 * Syncs the mobile gallery counter (.product-details-mobile-counter__current) with the
 * slideshow via the 'slideshow:select' event, avoiding any ref conflicts.
 */
function initMobileGalleryCounters() {
  document.querySelectorAll('.product-details-gallery-mobile-nav').forEach((nav) => {
    const slideshowComponent = nav.closest('slideshow-component');
    if (!slideshowComponent) return;

    const mobileCurrentEl = nav.querySelector('.product-details-mobile-counter__current');
    if (!mobileCurrentEl) return;

    slideshowComponent.addEventListener('slideshow:select', (/** @type {CustomEvent} */ event) => {
      mobileCurrentEl.textContent = String(event.detail.index + 1);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileGalleryCounters);
} else {
  initMobileGalleryCounters();
}
